module.exports = __webpack_public_path__ + "img/4_21.06.02_Series96_AnnixHomes_R2_01 (1).5c6027e1.jpg";